export const countryList = [
    {
        name: "Afghanistan",
        dial_code: "+93",
        code: "AF",
    },
    {
        name: "Albania",
        dial_code: "+355",
        code: "AL",
    },
    {
        name: "Algeria",
        dial_code: "+213",
        code: "DZ",
    },
    {
        name: "Andorra",
        dial_code: "+376",
        code: "AD",
    },
    {
        name: "Angola",
        dial_code: "+244",
        code: "AO",
    },
    {
        name: "Antigua and Barbuda",
        dial_code: "+1268",
        code: "AG",
    },
    {
        name: "Argentina",
        dial_code: "+54",
        code: "AR",
    },
    {
        name: "Armenia",
        dial_code: "+374",
        code: "AM",
    },
    {
        name: "Aruba",
        dial_code: "+297",
        code: "AW",
    },
    {
        name: "Australia",
        dial_code: "+61",
        code: "AU",
    },
    {
        name: "Austria",
        dial_code: "+43",
        code: "AT",
    },
    {
        name: "Azerbaijan",
        dial_code: "+994",
        code: "AZ",
    },
    {
        name: "Bahamas",
        dial_code: "+1242",
        code: "BS",
    },
    {
        name: "Bahrain",
        dial_code: "+973",
        code: "BH",
    },
    {
        name: "Bangladesh",
        dial_code: "+880",
        code: "BD",
    },
    {
        name: "Barbados",
        dial_code: "+1246",
        code: "BB",
    },
    {
        name: "Belarus",
        dial_code: "+375",
        code: "BY",
    },
    {
        name: "Belgium",
        dial_code: "+32",
        code: "BE",
    },
    {
        name: "Belize",
        dial_code: "+501",
        code: "BZ",
    },
    {
        name: "Benin",
        dial_code: "+229",
        code: "BJ",
    },
    {
        name: "Bermuda",
        dial_code: "+1441",
        code: "BM",
    },
    {
        name: "Bhutan",
        dial_code: "+975",
        code: "BT",
    },
    {
        name: "Bolivia, Plurinational State of",
        dial_code: "+591",
        code: "BO",
    },
    {
        name: "Bosnia and Herzegovina",
        dial_code: "+387",
        code: "BA",
    },
    {
        name: "Botswana",
        dial_code: "+267",
        code: "BW",
    },
    {
        name: "Brazil",
        dial_code: "+55",
        code: "BR",
    },
    {
        name: "British Indian Ocean Territory",
        dial_code: "+246",
        code: "IO",
    },
    {
        name: "Brunei Darussalam",
        dial_code: "+673",
        code: "BN",
    },
    {
        name: "Bulgaria",
        dial_code: "+359",
        code: "BG",
    },
    {
        name: "Burkina Faso",
        dial_code: "+226",
        code: "BF",
    },
    {
        name: "Burundi",
        dial_code: "+257",
        code: "BI",
    },
    {
        name: "Cambodia",
        dial_code: "+855",
        code: "KH",
    },
    {
        name: "Cameroon",
        dial_code: "+237",
        code: "CM",
    },
    {
        name: "Canada",
        dial_code: "+1",
        code: "CA",
    },
    {
        name: "Cape Verde",
        dial_code: "+238",
        code: "CV",
    },
    {
        name: "Cayman Islands",
        dial_code: "+ 345",
        code: "KY",
    },
    {
        name: "Central African Republic",
        dial_code: "+236",
        code: "CF",
    },
    {
        name: "Chad",
        dial_code: "+235",
        code: "TD",
    },
    {
        name: "Chile",
        dial_code: "+56",
        code: "CL",
    },
    {
        name: "China",
        dial_code: "+86",
        code: "CN",
    },
    {
        name: "Christmas Island",
        dial_code: "+61",
        code: "CX",
    },
    {
        name: "Cocos (Keeling) Islands",
        dial_code: "+61",
        code: "CC",
    },
    {
        name: "Colombia",
        dial_code: "+57",
        code: "CO",
    },
    {
        name: "Comoros",
        dial_code: "+269",
        code: "KM",
    },
    {
        name: "Congo",
        dial_code: "+242",
        code: "CG",
    },
    {
        name: "Congo, The Democratic Republic of the Congo",
        dial_code: "+243",
        code: "CD",
    },
    {
        name: "Cook Islands",
        dial_code: "+682",
        code: "CK",
    },
    {
        name: "Costa Rica",
        dial_code: "+506",
        code: "CR",
    },
    {
        name: "Cote d'Ivoire",
        dial_code: "+225",
        code: "CI",
    },
    {
        name: "Croatia",
        dial_code: "+385",
        code: "HR",
    },
    {
        name: "Cuba",
        dial_code: "+53",
        code: "CU",
    },
    {
        name: "Cyprus",
        dial_code: "+357",
        code: "CY",
    },
    {
        name: "Czech Republic",
        dial_code: "+420",
        code: "CZ",
    },
    {
        name: "Denmark",
        dial_code: "+45",
        code: "DK",
    },
    {
        name: "Djibouti",
        dial_code: "+253",
        code: "DJ",
    },
    {
        name: "Dominica",
        dial_code: "+1767",
        code: "DM",
    },
    {
        name: "Dominican Republic",
        dial_code: "+1849",
        code: "DO",
    },
    {
        name: "Ecuador",
        dial_code: "+593",
        code: "EC",
    },
    {
        name: "Egypt",
        dial_code: "+20",
        code: "EG",
    },
    {
        name: "El Salvador",
        dial_code: "+503",
        code: "SV",
    },
    {
        name: "Equatorial Guinea",
        dial_code: "+240",
        code: "GQ",
    },
    {
        name: "Eritrea",
        dial_code: "+291",
        code: "ER",
    },
    {
        name: "Estonia",
        dial_code: "+372",
        code: "EE",
    },
    {
        name: "Ethiopia",
        dial_code: "+251",
        code: "ET",
    },
    {
        name: "Falkland Islands (Malvinas)",
        dial_code: "+500",
        code: "FK",
    },
    {
        name: "Faroe Islands",
        dial_code: "+298",
        code: "FO",
    },
    {
        name: "Fiji",
        dial_code: "+679",
        code: "FJ",
    },
    {
        name: "Finland",
        dial_code: "+358",
        code: "FI",
    },
    {
        name: "France",
        dial_code: "+33",
        code: "FR",
    },
    {
        name: "French Guiana",
        dial_code: "+594",
        code: "GF",
    },
    {
        name: "French Polynesia",
        dial_code: "+689",
        code: "PF",
    },
    {
        name: "Gabon",
        dial_code: "+241",
        code: "GA",
    },
    {
        name: "Gambia",
        dial_code: "+220",
        code: "GM",
    },
    {
        name: "Georgia",
        dial_code: "+995",
        code: "GE",
    },
    {
        name: "Germany",
        dial_code: "+49",
        code: "DE",
    },
    {
        name: "Ghana",
        dial_code: "+233",
        code: "GH",
    },
    {
        name: "Gibraltar",
        dial_code: "+350",
        code: "GI",
    },
    {
        name: "Greece",
        dial_code: "+30",
        code: "GR",
    },
    {
        name: "Greenland",
        dial_code: "+299",
        code: "GL",
    },
    {
        name: "Grenada",
        dial_code: "+1473",
        code: "GD",
    },
    {
        name: "Guadeloupe",
        dial_code: "+590",
        code: "GP",
    },
    {
        name: "Guam",
        dial_code: "+1671",
        code: "GU",
    },
    {
        name: "Guatemala",
        dial_code: "+502",
        code: "GT",
    },
    {
        name: "Guernsey",
        dial_code: "+44",
        code: "GG",
    },
    {
        name: "Guinea",
        dial_code: "+224",
        code: "GN",
    },
    {
        name: "Guinea-Bissau",
        dial_code: "+245",
        code: "GW",
    },
    {
        name: "Guyana",
        dial_code: "+595",
        code: "GY",
    },
    {
        name: "Haiti",
        dial_code: "+509",
        code: "HT",
    },
    {
        name: "Holy See (Vatican City State)",
        dial_code: "+379",
        code: "VA",
    },
    {
        name: "Honduras",
        dial_code: "+504",
        code: "HN",
    },
    {
        name: "Hong Kong",
        dial_code: "+852",
        code: "HK",
    },
    {
        name: "Hungary",
        dial_code: "+36",
        code: "HU",
    },
    {
        name: "Iceland",
        dial_code: "+354",
        code: "IS",
    },
    {
        name: "India",
        dial_code: "+91",
        code: "IN",
    },
    {
        name: "Indonesia",
        dial_code: "+62",
        code: "ID",
    },
    {
        name: "Iran, Islamic Republic of Persian Gulf",
        dial_code: "+98",
        code: "IR",
    },
    {
        name: "Iraq",
        dial_code: "+964",
        code: "IQ",
    },
    {
        name: "Ireland",
        dial_code: "+353",
        code: "IE",
    },
    {
        name: "Isle of Man",
        dial_code: "+44",
        code: "IM",
    },
    {
        name: "Israel",
        dial_code: "+972",
        code: "IL",
    },
    {
        name: "Italy",
        dial_code: "+39",
        code: "IT",
    },
    {
        name: "Jamaica",
        dial_code: "+1876",
        code: "JM",
    },
    {
        name: "Japan",
        dial_code: "+81",
        code: "JP",
    },
    {
        name: "Jersey",
        dial_code: "+44",
        code: "JE",
    },
    {
        name: "Jordan",
        dial_code: "+962",
        code: "JO",
    },
    {
        name: "Kazakhstan",
        dial_code: "+77",
        code: "KZ",
    },
    {
        name: "Kenya",
        dial_code: "+254",
        code: "KE",
    },
    {
        name: "Kiribati",
        dial_code: "+686",
        code: "KI",
    },
    {
        name: "Korea, Democratic People's Republic of Korea",
        dial_code: "+850",
        code: "KP",
    },
    {
        name: "Korea, Republic of South Korea",
        dial_code: "+82",
        code: "KR",
    },
    {
        name: "Kuwait",
        dial_code: "+965",
        code: "KW",
    },
    {
        name: "Kyrgyzstan",
        dial_code: "+996",
        code: "KG",
    },
    {
        name: "Laos",
        dial_code: "+856",
        code: "LA",
    },
    {
        name: "Latvia",
        dial_code: "+371",
        code: "LV",
    },
    {
        name: "Lebanon",
        dial_code: "+961",
        code: "LB",
    },
    {
        name: "Lesotho",
        dial_code: "+266",
        code: "LS",
    },
    {
        name: "Liberia",
        dial_code: "+231",
        code: "LR",
    },
    {
        name: "Libyan Arab Jamahiriya",
        dial_code: "+218",
        code: "LY",
    },
    {
        name: "Liechtenstein",
        dial_code: "+423",
        code: "LI",
    },
    {
        name: "Lithuania",
        dial_code: "+370",
        code: "LT",
    },
    {
        name: "Luxembourg",
        dial_code: "+352",
        code: "LU",
    },
    {
        name: "Macao",
        dial_code: "+853",
        code: "MO",
    },
    {
        name: "Macedonia",
        dial_code: "+389",
        code: "MK",
    },
    {
        name: "Madagascar",
        dial_code: "+261",
        code: "MG",
    },
    {
        name: "Malawi",
        dial_code: "+265",
        code: "MW",
    },
    {
        name: "Malaysia",
        dial_code: "+60",
        code: "MY",
    },
    {
        name: "Maldives",
        dial_code: "+960",
        code: "MV",
    },
    {
        name: "Mali",
        dial_code: "+223",
        code: "ML",
    },
    {
        name: "Malta",
        dial_code: "+356",
        code: "MT",
    },
    {
        name: "Marshall Islands",
        dial_code: "+692",
        code: "MH",
    },
    {
        name: "Martinique",
        dial_code: "+596",
        code: "MQ",
    },
    {
        name: "Mauritania",
        dial_code: "+222",
        code: "MR",
    },
    {
        name: "Mauritius",
        dial_code: "+230",
        code: "MU",
    },
    {
        name: "Mayotte",
        dial_code: "+262",
        code: "YT",
    },
    {
        name: "Mexico",
        dial_code: "+52",
        code: "MX",
    },
    {
        name: "Micronesia, Federated States of Micronesia",
        dial_code: "+691",
        code: "FM",
    },
    {
        name: "Moldova",
        dial_code: "+373",
        code: "MD",
    },
    {
        name: "Monaco",
        dial_code: "+377",
        code: "MC",
    },
    {
        name: "Mongolia",
        dial_code: "+976",
        code: "MN",
    },
    {
        name: "Montenegro",
        dial_code: "+382",
        code: "ME",
    },
    {
        name: "Montserrat",
        dial_code: "+1664",
        code: "MS",
    },
    {
        name: "Morocco",
        dial_code: "+212",
        code: "MA",
    },
    {
        name: "Mozambique",
        dial_code: "+258",
        code: "MZ",
    },
    {
        name: "Myanmar",
        dial_code: "+95",
        code: "MM",
    },
    {
        name: "Namibia",
        dial_code: "+264",
        code: "NA",
    },
    {
        name: "Nauru",
        dial_code: "+674",
        code: "NR",
    },
    {
        name: "Nepal",
        dial_code: "+977",
        code: "NP",
    },
    {
        name: "Netherlands",
        dial_code: "+31",
        code: "NL",
    },
    {
        name: "Netherlands Antilles",
        dial_code: "+599",
        code: "AN",
    },
    {
        name: "New Caledonia",
        dial_code: "+687",
        code: "NC",
    },
    {
        name: "New Zealand",
        dial_code: "+64",
        code: "NZ",
    },
    {
        name: "Nicaragua",
        dial_code: "+505",
        code: "NI",
    },
    {
        name: "Niger",
        dial_code: "+227",
        code: "NE",
    },
    {
        name: "Nigeria",
        dial_code: "+234",
        code: "NG",
    },
    {
        name: "Niue",
        dial_code: "+683",
        code: "NU",
    },
    {
        name: "Norfolk Island",
        dial_code: "+672",
        code: "NF",
    },
    {
        name: "Northern Mariana Islands",
        dial_code: "+1670",
        code: "MP",
    },
    {
        name: "Norway",
        dial_code: "+47",
        code: "NO",
    },
    {
        name: "Oman",
        dial_code: "+968",
        code: "OM",
    },
    {
        name: "Pakistan",
        dial_code: "+92",
        code: "PK",
    },
    {
        name: "Palau",
        dial_code: "+680",
        code: "PW",
    },
    {
        name: "Palestinian Territory, Occupied",
        dial_code: "+970",
        code: "PS",
    },
    {
        name: "Panama",
        dial_code: "+507",
        code: "PA",
    },
    {
        name: "Papua New Guinea",
        dial_code: "+675",
        code: "PG",
    },
    {
        name: "Paraguay",
        dial_code: "+595",
        code: "PY",
    },
    {
        name: "Peru",
        dial_code: "+51",
        code: "PE",
    },
    {
        name: "Philippines",
        dial_code: "+63",
        code: "PH",
    },
    {
        name: "Pitcairn",
        dial_code: "+872",
        code: "PN",
    },
    {
        name: "Poland",
        dial_code: "+48",
        code: "PL",
    },
    {
        name: "Portugal",
        dial_code: "+351",
        code: "PT",
    },
    {
        name: "Puerto Rico",
        dial_code: "+1939",
        code: "PR",
    },
    {
        name: "Qatar",
        dial_code: "+974",
        code: "QA",
    },
    {
        name: "Romania",
        dial_code: "+40",
        code: "RO",
    },
    {
        name: "Russia",
        dial_code: "+7",
        code: "RU",
    },
    {
        name: "Rwanda",
        dial_code: "+250",
        code: "RW",
    },
    {
        name: "Reunion",
        dial_code: "+262",
        code: "RE",
    },
    {
        name: "Saint Barthelemy",
        dial_code: "+590",
        code: "BL",
    },
    {
        name: "Saint Helena, Ascension and Tristan Da Cunha",
        dial_code: "+290",
        code: "SH",
    },
    {
        name: "Saint Kitts and Nevis",
        dial_code: "+1869",
        code: "KN",
    },
    {
        name: "Saint Lucia",
        dial_code: "+1758",
        code: "LC",
    },
    {
        name: "Saint Martin",
        dial_code: "+590",
        code: "MF",
    },
    {
        name: "Saint Pierre and Miquelon",
        dial_code: "+508",
        code: "PM",
    },
    {
        name: "Saint Vincent and the Grenadines",
        dial_code: "+1784",
        code: "VC",
    },
    {
        name: "Samoa",
        dial_code: "+685",
        code: "WS",
    },
    {
        name: "San Marino",
        dial_code: "+378",
        code: "SM",
    },
    {
        name: "Sao Tome and Principe",
        dial_code: "+239",
        code: "ST",
    },
    {
        name: "Saudi Arabia",
        dial_code: "+966",
        code: "SA",
    },
    {
        name: "Senegal",
        dial_code: "+221",
        code: "SN",
    },
    {
        name: "Serbia",
        dial_code: "+381",
        code: "RS",
    },
    {
        name: "Seychelles",
        dial_code: "+248",
        code: "SC",
    },
    {
        name: "Sierra Leone",
        dial_code: "+232",
        code: "SL",
    },
    {
        name: "Singapore",
        dial_code: "+65",
        code: "SG",
    },
    {
        name: "Slovakia",
        dial_code: "+421",
        code: "SK",
    },
    {
        name: "Slovenia",
        dial_code: "+386",
        code: "SI",
    },
    {
        name: "Solomon Islands",
        dial_code: "+677",
        code: "SB",
    },
    {
        name: "Somalia",
        dial_code: "+252",
        code: "SO",
    },
    {
        name: "South Africa",
        dial_code: "+27",
        code: "ZA",
    },
    {
        name: "South Sudan",
        dial_code: "+211",
        code: "SS",
    },
    {
        name: "South Georgia and the South Sandwich Islands",
        dial_code: "+500",
        code: "GS",
    },
    {
        name: "Spain",
        dial_code: "+34",
        code: "ES",
    },
    {
        name: "Sri Lanka",
        dial_code: "+94",
        code: "LK",
    },
    {
        name: "Sudan",
        dial_code: "+249",
        code: "SD",
    },
    {
        name: "Suriname",
        dial_code: "+597",
        code: "SR",
    },
    {
        name: "Svalbard and Jan Mayen",
        dial_code: "+47",
        code: "SJ",
    },
    {
        name: "Swaziland",
        dial_code: "+268",
        code: "SZ",
    },
    {
        name: "Sweden",
        dial_code: "+46",
        code: "SE",
    },
    {
        name: "Switzerland",
        dial_code: "+41",
        code: "CH",
    },
    {
        name: "Syrian Arab Republic",
        dial_code: "+963",
        code: "SY",
    },
    {
        name: "Taiwan",
        dial_code: "+886",
        code: "TW",
    },
    {
        name: "Tajikistan",
        dial_code: "+992",
        code: "TJ",
    },
    {
        name: "Tanzania, United Republic of Tanzania",
        dial_code: "+255",
        code: "TZ",
    },
    {
        name: "Thailand",
        dial_code: "+66",
        code: "TH",
    },
    {
        name: "Timor-Leste",
        dial_code: "+670",
        code: "TL",
    },
    {
        name: "Togo",
        dial_code: "+228",
        code: "TG",
    },
    {
        name: "Tokelau",
        dial_code: "+690",
        code: "TK",
    },
    {
        name: "Tonga",
        dial_code: "+676",
        code: "TO",
    },
    {
        name: "Trinidad and Tobago",
        dial_code: "+1868",
        code: "TT",
    },
    {
        name: "Tunisia",
        dial_code: "+216",
        code: "TN",
    },
    {
        name: "Turkey",
        dial_code: "+90",
        code: "TR",
    },
    {
        name: "Turkmenistan",
        dial_code: "+993",
        code: "TM",
    },
    {
        name: "Turks and Caicos Islands",
        dial_code: "+1649",
        code: "TC",
    },
    {
        name: "Tuvalu",
        dial_code: "+688",
        code: "TV",
    },
    {
        name: "Uganda",
        dial_code: "+256",
        code: "UG",
    },
    {
        name: "Ukraine",
        dial_code: "+380",
        code: "UA",
    },
    {
        name: "United Arab Emirates",
        dial_code: "+971",
        code: "AE",
    },
    {
        name: "United Kingdom",
        dial_code: "+44",
        code: "GB",
    },
    {
        name: "United States",
        dial_code: "+1",
        code: "US",
    },
    {
        name: "Uruguay",
        dial_code: "+598",
        code: "UY",
    },
    {
        name: "Uzbekistan",
        dial_code: "+998",
        code: "UZ",
    },
    {
        name: "Vanuatu",
        dial_code: "+678",
        code: "VU",
    },
    {
        name: "Venezuela, Bolivarian Republic of Venezuela",
        dial_code: "+58",
        code: "VE",
    },
    {
        name: "Vietnam",
        dial_code: "+84",
        code: "VN",
    },
    {
        name: "Virgin Islands, British",
        dial_code: "+1284",
        code: "VG",
    },
    {
        name: "Virgin Islands, U.S.",
        dial_code: "+1340",
        code: "VI",
    },
    {
        name: "Wallis and Futuna",
        dial_code: "+681",
        code: "WF",
    },
    {
        name: "Yemen",
        dial_code: "+967",
        code: "YE",
    },
    {
        name: "Zambia",
        dial_code: "+260",
        code: "ZM",
    },
    {
        name: "Zimbabwe",
        dial_code: "+263",
        code: "ZW",
    },
];

export const countryColorList = [
    {
        country: "Afghanistan",
        color: "#8850CF",
        code: "AF",
    },
    {
        country: "Albania",
        color: "#038C37",
        code: "AL",
    },
    {
        country: "Algeria",
        color: "#AD5E15",
        code: "DZ",
    },
    {
        country: "Andorra",
        color: "#7FF1A5",
        code: "AD",
    },
    {
        country: "Angola",
        color: "#B62DDC",
        code: "AO",
    },
    {
        country: "Antigua and Barbuda",
        color: "#BD0BBF",
        code: "AG",
    },
    {
        country: "Argentina",
        color: "#A83F4B",
        code: "AR",
    },
    {
        country: "Armenia",
        color: "#2BBE45",
        code: "AM",
    },
    {
        country: "Aruba",
        color: "#DAE14E",
        code: "AW",
    },
    {
        country: "Australia",
        color: "#5212E5",
        code: "AU",
    },
    {
        country: "Austria",
        color: "#EA2EDD",
        code: "AT",
    },
    {
        country: "Azerbaijan",
        color: "#4741C1",
        code: "AZ",
    },
    {
        country: "Bahamas",
        color: "#4F4B5F",
        code: "BS",
    },
    {
        country: "Bahrain",
        color: "#13700A",
        code: "BH",
    },
    {
        country: "Bangladesh",
        color: "#5C49D0",
        code: "BD",
    },
    {
        country: "Barbados",
        color: "#F465F0",
        code: "BB",
    },
    {
        country: "Belarus",
        color: "#7F1B20",
        code: "BY",
    },
    {
        country: "Belgium",
        color: "#456BFC",
        code: "BE",
    },
    {
        country: "Belize",
        color: "#90C76F",
        code: "BZ",
    },
    {
        country: "Benin",
        color: "#C76FF4",
        code: "BJ",
    },
    {
        country: "Bermuda",
        color: "#08E5B2",
        code: "BM",
    },
    {
        country: "Bhutan",
        color: "#4081E8",
        code: "BT",
    },
    {
        country: "Bolivia, Plurinational State of",
        color: "#01BCF9",
        code: "BO",
    },
    {
        country: "Bosnia and Herzegovina",
        color: "#EE30F8",
        code: "BA",
    },
    {
        country: "Botswana",
        color: "#41E95E",
        code: "BW",
    },
    {
        country: "Brazil",
        color: "#10BC55",
        code: "BR",
    },
    {
        country: "British Indian Ocean Territory",
        color: "#EDC7EC",
        code: "IO",
    },
    {
        country: "Brunei Darussalam",
        color: "#BB6965",
        code: "BN",
    },
    {
        country: "Bulgaria",
        color: "#51BEB1",
        code: "BG",
    },
    {
        country: "Burkina Faso",
        color: "#7CC664",
        code: "BF",
    },
    {
        country: "Burundi",
        color: "#A0FC63",
        code: "BI",
    },
    {
        country: "Cambodia",
        color: "#AAE368",
        code: "KH",
    },
    {
        country: "Cameroon",
        color: "#311F46",
        code: "CM",
    },
    {
        country: "Canada",
        color: "#AF2E00",
        code: "CA",
    },
    {
        country: "Cape Verde",
        color: "#0B03DD",
        code: "CV",
    },
    {
        country: "Cayman Islands",
        color: "#8A2972",
        code: "KY",
    },
    {
        country: "Central African Republic",
        color: "#EEA648",
        code: "CF",
    },
    {
        country: "Chad",
        color: "#25F1EF",
        code: "TD",
    },
    {
        country: "Chile",
        color: "#A48BA4",
        code: "CL",
    },
    {
        country: "China",
        color: "#CCB8FC",
        code: "CN",
    },
    {
        country: "Christmas Island",
        color: "#3489BF",
        code: "CX",
    },
    {
        country: "Cocos (Keeling) Islands",
        color: "#CD8679",
        code: "CC",
    },
    {
        country: "Colombia",
        color: "#63605F",
        code: "CO",
    },
    {
        country: "Comoros",
        color: "#FF2B79",
        code: "KM",
    },
    {
        country: "Congo",
        color: "#9391B7",
        code: "CG",
    },
    {
        country: "Congo, The Democratic Republic of the Congo",
        color: "#D1D717",
        code: "CD",
    },
    {
        country: "Cook Islands",
        color: "#4BECD8",
        code: "CK",
    },
    {
        country: "Costa Rica",
        color: "#B059E2",
        code: "CR",
    },
    {
        country: "Cote d'Ivoire",
        color: "#7470BF",
        code: "CI",
    },
    {
        country: "Croatia",
        color: "#F30AFC",
        code: "HR",
    },
    {
        country: "Cuba",
        color: "#02FF45",
        code: "CU",
    },
    {
        country: "Cyprus",
        color: "#7961B9",
        code: "CY",
    },
    {
        country: "Czech Republic",
        color: "#64FC44",
        code: "CZ",
    },
    {
        country: "Denmark",
        color: "#F3C4A3",
        code: "DK",
    },
    {
        country: "Djibouti",
        color: "#4B2AE1",
        code: "DJ",
    },
    {
        country: "Dominica",
        color: "#59342C",
        code: "DM",
    },
    {
        country: "Dominican Republic",
        color: "#04B05F",
        code: "DO",
    },
    {
        country: "Ecuador",
        color: "#7FF238",
        code: "EC",
    },
    {
        country: "Egypt",
        color: "#7CC9EA",
        code: "EG",
    },
    {
        country: "El Salvador",
        color: "#A7BEFF",
        code: "SV",
    },
    {
        country: "Equatorial Guinea",
        color: "#3F9E5A",
        code: "GQ",
    },
    {
        country: "Eritrea",
        color: "#5C828B",
        code: "ER",
    },
    {
        country: "Estonia",
        color: "#2D54AF",
        code: "EE",
    },
    {
        country: "Ethiopia",
        color: "#8ADCEA",
        code: "ET",
    },
    {
        country: "Falkland Islands (Malvinas)",
        color: "#CAA41D",
        code: "FK",
    },
    {
        country: "Faroe Islands",
        color: "#9AC4E8",
        code: "FO",
    },
    {
        country: "Fiji",
        color: "#3B7E77",
        code: "FJ",
    },
    {
        country: "Finland",
        color: "#38E4C2",
        code: "FI",
    },
    {
        country: "France",
        color: "#8A8480",
        code: "FR",
    },
    {
        country: "French Guiana",
        color: "#5D7E05",
        code: "GF",
    },
    {
        country: "French Polynesia",
        color: "#2985B3",
        code: "PF",
    },
    {
        country: "Gabon",
        color: "#4FEBEC",
        code: "GA",
    },
    {
        country: "Gambia",
        color: "#A69C81",
        code: "GM",
    },
    {
        country: "Georgia",
        color: "#C0FEE6",
        code: "GE",
    },
    {
        country: "Germany",
        color: "#3ACEC1",
        code: "DE",
    },
    {
        country: "Ghana",
        color: "#26C364",
        code: "GH",
    },
    {
        country: "Gibraltar",
        color: "#EE1477",
        code: "GI",
    },
    {
        country: "Greece",
        color: "#72E1F2",
        code: "GR",
    },
    {
        country: "Greenland",
        color: "#21B330",
        code: "GL",
    },
    {
        country: "Grenada",
        color: "#B35080",
        code: "GD",
    },
    {
        country: "Guadeloupe",
        color: "#B9BA10",
        code: "GP",
    },
    {
        country: "Guam",
        color: "#FB7108",
        code: "GU",
    },
    {
        country: "Guatemala",
        color: "#291464",
        code: "GT",
    },
    {
        country: "Guernsey",
        color: "#29F07A",
        code: "GG",
    },
    {
        country: "Guinea",
        color: "#96049F",
        code: "GN",
    },
    {
        country: "Guinea-Bissau",
        color: "#47FDA8",
        code: "GW",
    },
    {
        country: "Guyana",
        color: "#802510",
        code: "GY",
    },
    {
        country: "Haiti",
        color: "#2E346A",
        code: "HT",
    },
    {
        country: "Holy See (Vatican City State)",
        color: "#104CC5",
        code: "VA",
    },
    {
        country: "Honduras",
        color: "#8A80F3",
        code: "HN",
    },
    {
        country: "Hong Kong",
        color: "#8E1E96",
        code: "HK",
    },
    {
        country: "Hungary",
        color: "#040165",
        code: "HU",
    },
    {
        country: "Iceland",
        color: "#32ABC0",
        code: "IS",
    },
    {
        country: "India",
        color: "#298ED1",
        code: "IN",
    },
    {
        country: "Indonesia",
        color: "#742C43",
        code: "ID",
    },
    {
        country: "Iran, Islamic Republic of Persian Gulf",
        color: "#B98DF4",
        code: "IR",
    },
    {
        country: "Iraq",
        color: "#851B30",
        code: "IQ",
    },
    {
        country: "Ireland",
        color: "#71C301",
        code: "IE",
    },
    {
        country: "Isle of Man",
        color: "#1D36DF",
        code: "IM",
    },
    {
        country: "Israel",
        color: "#41B3B5",
        code: "IL",
    },
    {
        country: "Italy",
        color: "#402DB3",
        code: "IT",
    },
    {
        country: "Jamaica",
        color: "#D55ED1",
        code: "JM",
    },
    {
        country: "Japan",
        color: "#239324",
        code: "JP",
    },
    {
        country: "Jersey",
        color: "#000727",
        code: "JE",
    },
    {
        country: "Jordan",
        color: "#98BB99",
        code: "JO",
    },
    {
        country: "Kazakhstan",
        color: "#5ADF7F",
        code: "KZ",
    },
    {
        country: "Kenya",
        color: "#FE9F9A",
        code: "KE",
    },
    {
        country: "Kiribati",
        color: "#3757EC",
        code: "KI",
    },
    {
        country: "Korea, Democratic People's Republic of Korea",
        color: "#CD5C98",
        code: "KP",
    },
    {
        country: "Korea, Republic of South Korea",
        color: "#18196B",
        code: "KR",
    },
    {
        country: "Kuwait",
        color: "#2E79D5",
        code: "KW",
    },
    {
        country: "Kyrgyzstan",
        color: "#66B9CC",
        code: "KG",
    },
    {
        country: "Laos",
        color: "#2CEA92",
        code: "LA",
    },
    {
        country: "Latvia",
        color: "#CBFFAD",
        code: "LV",
    },
    {
        country: "Lebanon",
        color: "#8E9572",
        code: "LB",
    },
    {
        country: "Lesotho",
        color: "#668480",
        code: "LS",
    },
    {
        country: "Liberia",
        color: "#FEA9A4",
        code: "LR",
    },
    {
        country: "Libyan Arab Jamahiriya",
        color: "#22748E",
        code: "LY",
    },
    {
        country: "Liechtenstein",
        color: "#B5DFDD",
        code: "LI",
    },
    {
        country: "Lithuania",
        color: "#CB0D48",
        code: "LT",
    },
    {
        country: "Luxembourg",
        color: "#D54DA2",
        code: "LU",
    },
    {
        country: "Macao",
        color: "#BC3366",
        code: "MO",
    },
    {
        country: "Macedonia",
        color: "#DBAEA7",
        code: "MK",
    },
    {
        country: "Madagascar",
        color: "#8644BC",
        code: "MG",
    },
    {
        country: "Malawi",
        color: "#BA2847",
        code: "MW",
    },
    {
        country: "Malaysia",
        color: "#A36273",
        code: "MY",
    },
    {
        country: "Maldives",
        color: "#12E816",
        code: "MV",
    },
    {
        country: "Mali",
        color: "#83FE09",
        code: "ML",
    },
    {
        country: "Malta",
        color: "#2BF658",
        code: "MT",
    },
    {
        country: "Marshall Islands",
        color: "#221AD4",
        code: "MH",
    },
    {
        country: "Martinique",
        color: "#1F003C",
        code: "MQ",
    },
    {
        country: "Mauritania",
        color: "#5A7418",
        code: "MR",
    },
    {
        country: "Mauritius",
        color: "#E74B50",
        code: "MU",
    },
    {
        country: "Mayotte",
        color: "#0D76D4",
        code: "YT",
    },
    {
        country: "Mexico",
        color: "#E59481",
        code: "MX",
    },
    {
        country: "Micronesia, Federated States of Micronesia",
        color: "#093B80",
        code: "FM",
    },
    {
        country: "Moldova",
        color: "#A2104F",
        code: "MD",
    },
    {
        country: "Monaco",
        color: "#BD0392",
        code: "MC",
    },
    {
        country: "Mongolia",
        color: "#1A688B",
        code: "MN",
    },
    {
        country: "Montenegro",
        color: "#1F89A1",
        code: "ME",
    },
    {
        country: "Montserrat",
        color: "#76C04C",
        code: "MS",
    },
    {
        country: "Morocco",
        color: "#3D367A",
        code: "MA",
    },
    {
        country: "Mozambique",
        color: "#031AD7",
        code: "MZ",
    },
    {
        country: "Myanmar",
        color: "#DFB997",
        code: "MM",
    },
    {
        country: "Namibia",
        color: "#86FF07",
        code: "NA",
    },
    {
        country: "Nauru",
        color: "#AB01D5",
        code: "NR",
    },
    {
        country: "Nepal",
        color: "#A41F4C",
        code: "NP",
    },
    {
        country: "Netherlands",
        color: "#9AF6D7",
        code: "NL",
    },
    {
        country: "Netherlands Antilles",
        color: "#10A77B",
        code: "AN",
    },
    {
        country: "New Caledonia",
        color: "#A889B2",
        code: "NC",
    },
    {
        country: "New Zealand",
        color: "#F751B3",
        code: "NZ",
    },
    {
        country: "Nicaragua",
        color: "#BCE838",
        code: "NI",
    },
    {
        country: "Niger",
        color: "#ADE50F",
        code: "NE",
    },
    {
        country: "Nigeria",
        color: "#018867",
        code: "NG",
    },
    {
        country: "Niue",
        color: "#1C22F8",
        code: "NU",
    },
    {
        country: "Norfolk Island",
        color: "#2A0A67",
        code: "NF",
    },
    {
        country: "Northern Mariana Islands",
        color: "#570D17",
        code: "MP",
    },
    {
        country: "Norway",
        color: "#B44C02",
        code: "NO",
    },
    {
        country: "Oman",
        color: "#82FEAE",
        code: "OM",
    },
    {
        country: "Pakistan",
        color: "#3DC272",
        code: "PK",
    },
    {
        country: "Palau",
        color: "#7C0604",
        code: "PW",
    },
    {
        country: "Palestinian Territory, Occupied",
        color: "#5556CF",
        code: "PS",
    },
    {
        country: "Panama",
        color: "#F2149D",
        code: "PA",
    },
    {
        country: "Papua New Guinea",
        color: "#E98C84",
        code: "PG",
    },
    {
        country: "Paraguay",
        color: "#FF9DCF",
        code: "PY",
    },
    {
        country: "Peru",
        color: "#DE104A",
        code: "PE",
    },
    {
        country: "Philippines",
        color: "#42467B",
        code: "PH",
    },
    {
        country: "Pitcairn",
        color: "#58EAAD",
        code: "PN",
    },
    {
        country: "Poland",
        color: "#A4C36D",
        code: "PL",
    },
    {
        country: "Portugal",
        color: "#9CC974",
        code: "PT",
    },
    {
        country: "Puerto Rico",
        color: "#868B6F",
        code: "PR",
    },
    {
        country: "Qatar",
        color: "#BB958F",
        code: "QA",
    },
    {
        country: "Romania",
        color: "#7F14E8",
        code: "RO",
    },
    {
        country: "Russia",
        color: "#8BCF5F",
        code: "RU",
    },
    {
        country: "Rwanda",
        color: "#82CF9A",
        code: "RW",
    },
    {
        country: "Reunion",
        color: "#1F457D",
        code: "RE",
    },
    {
        country: "Saint Barthelemy",
        color: "#98C02B",
        code: "BL",
    },
    {
        country: "Saint Helena, Ascension and Tristan Da Cunha",
        color: "#A92437",
        code: "SH",
    },
    {
        country: "Saint Kitts and Nevis",
        color: "#AA51A8",
        code: "KN",
    },
    {
        country: "Saint Lucia",
        color: "#097CE8",
        code: "LC",
    },
    {
        country: "Saint Martin",
        color: "#75AF8D",
        code: "MF",
    },
    {
        country: "Saint Pierre and Miquelon",
        color: "#6FB7F6",
        code: "PM",
    },
    {
        country: "Saint Vincent and the Grenadines",
        color: "#FCB1D1",
        code: "VC",
    },
    {
        country: "Samoa",
        color: "#60A856",
        code: "WS",
    },
    {
        country: "San Marino",
        color: "#CC3A4D",
        code: "SM",
    },
    {
        country: "Sao Tome and Principe",
        color: "#B30DFA",
        code: "ST",
    },
    {
        country: "Saudi Arabia",
        color: "#649C0E",
        code: "SA",
    },
    {
        country: "Senegal",
        color: "#2E64C2",
        code: "SN",
    },
    {
        country: "Serbia",
        color: "#150B0B",
        code: "RS",
    },
    {
        country: "Seychelles",
        color: "#622D34",
        code: "SC",
    },
    {
        country: "Sierra Leone",
        color: "#08E5C9",
        code: "SL",
    },
    {
        country: "Singapore",
        color: "#AB6072",
        code: "SG",
    },
    {
        country: "Slovakia",
        color: "#54FC74",
        code: "SK",
    },
    {
        country: "Slovenia",
        color: "#A52194",
        code: "SI",
    },
    {
        country: "Solomon Islands",
        color: "#E9AEF2",
        code: "SB",
    },
    {
        country: "Somalia",
        color: "#8565DA",
        code: "SO",
    },
    {
        country: "South Africa",
        color: "#EC36B2",
        code: "ZA",
    },
    {
        country: "South Sudan",
        color: "#03BDE3",
        code: "SS",
    },
    {
        country: "South Georgia and the South Sandwich Islands",
        color: "#3DA221",
        code: "GS",
    },
    {
        country: "Spain",
        color: "#B81F02",
        code: "ES",
    },
    {
        country: "Sri Lanka",
        color: "#A8D9F5",
        code: "LK",
    },
    {
        country: "Sudan",
        color: "#C77957",
        code: "SD",
    },
    {
        country: "Suriname",
        color: "#1F46EE",
        code: "SR",
    },
    {
        country: "Svalbard and Jan Mayen",
        color: "#85EA61",
        code: "SJ",
    },
    {
        country: "Swaziland",
        color: "#4DDB83",
        code: "SZ",
    },
    {
        country: "Sweden",
        color: "#BDE9AA",
        code: "SE",
    },
    {
        country: "Switzerland",
        color: "#FC0A93",
        code: "CH",
    },
    {
        country: "Syrian Arab Republic",
        color: "#015DBB",
        code: "SY",
    },
    {
        country: "Taiwan",
        color: "#C85F05",
        code: "TW",
    },
    {
        country: "Tajikistan",
        color: "#EBDB70",
        code: "TJ",
    },
    {
        country: "Tanzania, United Republic of Tanzania",
        color: "#6D4482",
        code: "TZ",
    },
    {
        country: "Thailand",
        color: "#AF38FC",
        code: "TH",
    },
    {
        country: "Timor-Leste",
        color: "#8CC9CA",
        code: "TL",
    },
    {
        country: "Togo",
        color: "#19108B",
        code: "TG",
    },
    {
        country: "Tokelau",
        color: "#28581D",
        code: "TK",
    },
    {
        country: "Tonga",
        color: "#E42423",
        code: "TO",
    },
    {
        country: "Trinidad and Tobago",
        color: "#1152BA",
        code: "TT",
    },
    {
        country: "Tunisia",
        color: "#5C5E1C",
        code: "TN",
    },
    {
        country: "Turkey",
        color: "#B5224C",
        code: "TR",
    },
    {
        country: "Turkmenistan",
        color: "#CCA422",
        code: "TM",
    },
    {
        country: "Turks and Caicos Islands",
        color: "#71CFA9",
        code: "TC",
    },
    {
        country: "Tuvalu",
        color: "#3C5F11",
        code: "TV",
    },
    {
        country: "Uganda",
        color: "#FC69FF",
        code: "UG",
    },
    {
        country: "Ukraine",
        color: "#AF49FC",
        code: "UA",
    },
    {
        country: "United Arab Emirates",
        color: "#067E42",
        code: "AE",
    },
    {
        country: "United Kingdom",
        color: "#B74E1D",
        code: "GB",
    },
    {
        country: "United States",
        color: "#43C9E4",
        code: "US",
    },
    {
        country: "Uruguay",
        color: "#AEF984",
        code: "UY",
    },
    {
        country: "Uzbekistan",
        color: "#CC310D",
        code: "UZ",
    },
    {
        country: "Vanuatu",
        color: "#F7EE7E",
        code: "VU",
    },
    {
        country: "Venezuela, Bolivarian Republic of Venezuela",
        color: "#DA105F",
        code: "VE",
    },
    {
        country: "Vietnam",
        color: "#04BB16",
        code: "VN",
    },
    {
        country: "Virgin Islands, British",
        color: "#80A614",
        code: "VG",
    },
    {
        country: "Virgin Islands, U.S.",
        color: "#C09B2C",
        code: "VI",
    },
    {
        country: "Wallis and Futuna",
        color: "#4FA050",
        code: "WF",
    },
    { country: "Kosovo", color: "#ff6633", code: "XK" },
    {
        country: "Yemen",
        color: "#7756B0",
        code: "YE",
    },
    {
        country: "Zambia",
        color: "#1F3E6F",
        code: "ZM",
    },
    {
        country: "Zimbabwe",
        color: "#7CA5EA",
        code: "ZW",
    },
];
